/*
 * Provides scroll to functionality
 *
 * @author BarrelNY
 *
 */
var ScrollDown = {
	init:function(){

		var templates = [
			'body.U2-template',
			'body.home-2020-page',
			'body.progress-page',
			'body.penthouse-page'
		].join();

		if (!$(templates).length) return;

		$('[data-trigger]')
			.on('click.waypoints', function(){

				var id  = $(this).attr('href')
				,   pos = $(id).position().top - (60+$('.header-links > .menu-item.current-menu-item > .sub-menu').innerHeight());

				$('html,body').stop().animate({scrollTop:pos}, 500, 'swing');

				return false;
			})
	},

	drop:function(){
		$('[data-trigger]')
			.off('click.waypoints');
	}
}

module.exports = ScrollDown;
